(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["defalken-hero"] && !Shopify.designMode) return;
  try {
    
  class DefalkenHeroSlider extends HTMLElement {
    connectedCallback() {
      // Children must be parsed before we query them. With Horizon's deferred,
      // compiled section JS they normally are — but retry once on the next frame
      // just in case this element is upgraded mid-parse.
      if (this._initialized) return;
      if (!this.init()) {
        requestAnimationFrame(() => this.init());
      }
    }

    init() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (!this.slides.length) return false;
      this._initialized = true;

      this.index = 0;
      this.timer = null;
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.style.setProperty('--progress-ms', this.interval + 'ms');

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10), true));
      });
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1, true));

      // Pause autoplay on hover / focus.
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.maybeStart());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.maybeStart());

      // Keyboard support.
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.goTo(this.index - 1, true);
        if (e.key === 'ArrowRight') this.goTo(this.index + 1, true);
      });

      // Only autoplay while visible.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.maybeStart();
            else this.stop();
          });
        }, { threshold: 0.2 });
        this.io.observe(this);
      } else {
        this.maybeStart();
      }

      // Activate the first slide (its iframe is already server-rendered).
      this.activate(0);
      return true;
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
    }

    loadVideo(slide) {
      const slot = slide.querySelector('.dfk-hero__video');
      if (!slot || !slide.dataset.youtube) return;
      if (slot.querySelector('iframe')) return; // already present (e.g. server-rendered slide 1)
      const id = slide.dataset.youtube;
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id +
        '?autoplay=1&mute=1&loop=1&playlist=' + id +
        '&controls=0&showinfo=0&modestbranding=1&playsinline=1&rel=0&disablekb=1&fs=0&iv_load_policy=3';
      iframe.title = '';
      iframe.tabIndex = -1;
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      slot.appendChild(iframe);
    }

    unloadVideo(slide) {
      const slot = slide.querySelector('.dfk-hero__video');
      if (slot) slot.innerHTML = ''; // keep only one video playing at a time
    }

    activate(i) {
      this.slides.forEach((slide, idx) => {
        const active = idx === i;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          this.loadVideo(slide);
        } else {
          slide.setAttribute('aria-hidden', 'true');
          this.unloadVideo(slide);
        }
      });
      this.dots.forEach((dot, idx) => {
        const on = idx === i;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.index = i;
    }

    goTo(i, fromUser) {
      const n = this.slides.length;
      this.activate(((i % n) + n) % n);
      if (fromUser) {
        this.stop();
        this.maybeStart();
      }
    }

    maybeStart() {
      if (!this.autoplay || this.reduceMotion || this.slides.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('defalken-hero-slider')) {
    customElements.define('defalken-hero-slider', DefalkenHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["defalken-notify"] && !Shopify.designMode) return;
  try {
    
  class DefalkenNotify extends HTMLElement {
    connectedCallback() {
      if (this.dataset.active !== 'true') return;
      // Hide the native purchase UI store-wide for this product.
      document.body.classList.add('dfk-notify-only');

      // Relocate the notify card inline, right where the buy buttons were,
      // so it reads as the primary action in the product details column.
      const buyForm = document.querySelector('form[action*="/cart/add"]');
      if (buyForm && buyForm.parentNode && buyForm.parentNode !== this.parentNode) {
        buyForm.parentNode.insertBefore(this, buyForm);
      }

      // If the customer just submitted, scroll the success message into view.
      if (this.querySelector('.dfk-notify__success')) {
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  if (!customElements.get('defalken-notify')) {
    customElements.define('defalken-notify', DefalkenNotify);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["defalken-sticky-atc"] && !Shopify.designMode) return;
  try {
    
    class DefalkenStickyAtc extends HTMLElement {
      connectedCallback() {
        this.form = document.querySelector('form[action*="/cart/add"]');
        this.addBtn = this.form
          ? this.form.querySelector('[type="submit"], button[name="add"], [name="add"]')
          : null;
        this.idInput = this.form ? this.form.querySelector('[name="id"]') : null;
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.compareEl = this.querySelector('[data-sticky-compare]');
        this.cta = this.querySelector('[data-sticky-add]');
        this.variants = this.parseVariants();
        this.shown = false;

        if (this.cta) this.cta.addEventListener('click', (e) => this.onAdd(e));

        const target = this.addBtn || this.form;
        if (target && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              const e = entries[0];
              this.toggle(!e.isIntersecting && e.boundingClientRect.top < 0);
            },
            { threshold: 0 }
          );
          this.io.observe(target);
        }

        if (this.form) {
          this.form.addEventListener('change', () => this.syncFromVariant());
        }
        this.syncFromVariant();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      parseVariants() {
        const tag = this.querySelector('[data-sticky-variants]');
        if (!tag) return {};
        try {
          return JSON.parse(tag.textContent);
        } catch (err) {
          return {};
        }
      }

      toggle(show) {
        if (show === this.shown) return;
        this.shown = show;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      syncFromVariant() {
        if (!this.idInput) return;
        const v = this.variants[this.idInput.value];
        if (!v) return;
        if (this.priceEl) this.priceEl.innerHTML = v.price;
        if (this.compareEl) {
          if (v.compare) {
            this.compareEl.innerHTML = v.compare;
            this.compareEl.hidden = false;
          } else {
            this.compareEl.hidden = true;
          }
        }
        if (this.cta) this.cta.disabled = !v.available;
      }

      onAdd(e) {
        e.preventDefault();
        if (this.addBtn) {
          this.addBtn.scrollIntoView({ block: 'center', behavior: 'instant' });
          this.addBtn.click();
        } else if (this.form) {
          if (this.form.requestSubmit) this.form.requestSubmit();
          else this.form.submit();
        }
      }
    }

    if (!customElements.get('defalken-sticky-atc')) {
      customElements.define('defalken-sticky-atc', DefalkenStickyAtc);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["defalken-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('defalken-slider')) {
    customElements.define(
      'defalken-slider',
      class DefalkenSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          const prev = this.querySelector('[data-prev]');
          const next = this.querySelector('[data-next]');
          if (prev) prev.addEventListener('click', () => { this.move(-1); this.pause(); });
          if (next) next.addEventListener('click', () => { this.move(1); this.pause(); });

          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!reduce) {
            this.addEventListener('mouseenter', () => this.stop());
            this.addEventListener('mouseleave', () => this.start());
            this.start();
          }
        }

        disconnectedCallback() { this.stop(); }

        start() {
          this.stop();
          this.autoplay = setInterval(() => this.advance(), 4500);
        }
        stop() { if (this.autoplay) clearInterval(this.autoplay); }
        pause() { this.stop(); setTimeout(() => this.start(), 9000); }

        advance() {
          const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
          if (atEnd) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.move(1);
          }
        }

        move(direction) {
          const slide = this.track.querySelector('[data-slide]');
          const step = slide
            ? slide.getBoundingClientRect().width + 20
            : this.track.clientWidth;
          this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
